import { baseApi } from "./baseApi";

const SHIPMENT_UNLOADING_BASE_URL = "/shipment-unLoading";

export const ShipmentUnLoadingApi = baseApi.injectEndpoints({
  tagTypes: ["ShipmentUnLoading"],

  endpoints: (builder) => ({
    addShipmentUnLoading: builder.mutation({
      query: (payLoad) => ({
        url: SHIPMENT_UNLOADING_BASE_URL,
        method: "POST",
        body: payLoad,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "ShipmentUnLoading", id: _id },
        { type: "ShipmentUnLoading", id: "LIST" },
      ],
    }),
    addShipmentUnloadingForDriver: builder.mutation({
      query: (payLoad) => ({
        url: `${SHIPMENT_UNLOADING_BASE_URL}/addUnLoadingForDriver`,
        method: "POST",
        body: payLoad,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "ShipmentUnLoading", id: _id },
        { type: "ShipmentUnLoading", id: "LIST" },
      ],
    }),
    addFreeUnloading: builder.mutation({
      query: (payLoad) => ({
        url: `${SHIPMENT_UNLOADING_BASE_URL}/freeUnloading`,
        method: "POST",
        body: payLoad,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "ShipmentUnLoading", id: _id },
        { type: "ShipmentUnLoading", id: "LIST" },
      ],
    }),

    listShipmentUnLoading: builder.query({
      query: (params) => ({
        url: SHIPMENT_UNLOADING_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "ShipmentUnLoading",
                _id,
              })),
              { type: "ShipmentUnLoading", id: "LIST" },
            ]
          : [{ type: "ShipmentUnLoading", id: "LIST" }],
    }),
    listShipmentUnLoadingCount: builder.query({
      query: (params) => ({
        url: `${SHIPMENT_UNLOADING_BASE_URL}/unLoadingCount`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "ShipmentUnLoading",
                _id,
              })),
              { type: "ShipmentUnLoading", id: "LIST" },
            ]
          : [{ type: "ShipmentUnLoading", id: "LIST" }],
    }),

    getDDLShipmentUnLoadingList: builder.query({
      query: (params) => ({
        url: `${SHIPMENT_UNLOADING_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "ShipmentUnLoading",
                _id,
              })),
              { type: "ShipmentUnLoading", id: "DDL" },
            ]
          : [{ type: "ShipmentUnLoading", id: "DDL" }],
    }),

    getShipmentUnLoadingDetail: builder.query({
      query: (transhipId) => `${SHIPMENT_UNLOADING_BASE_URL}/${transhipId}`,
      providesTags: (_result, _error, { _id }) => [
        { type: "ShipmentUnLoading", _id },
        { type: "ShipmentUnLoading", id: "LIST" },
      ],
    }),

    updateShipmentUnLoading: builder.mutation({
      query: ({ _id, ...body }) => ({
        url: `${SHIPMENT_UNLOADING_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { _id: id }) => [
        { type: "ShipmentUnLoading", id },
        { type: "ShipmentUnLoading", id: "LIST" },
      ],
    }),
    getDDLShipmentListForLoading: builder.query({
      query: (params) => ({
        url: `${SHIPMENT_UNLOADING_BASE_URL}/shipment-ddl`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({ type: "Shipment", id: _id })),
              { type: "Shipment", id: "DDL" },
            ]
          : [{ type: "Shipment", id: "DDL" }],
    }),
    getDdlUnLoadingByUnloadingBranch: builder.query({
      query: (params) => ({
        url: `${SHIPMENT_UNLOADING_BASE_URL}/ddlUnLoadingByUnloadingBranch`,
        params,
      }),
      transformResponse: (response) => {
        if (Array.isArray(response)) {
          return response;
        }
        if (response && typeof response === "object") {
          return Object.values(response);
        }
        return [];
      },
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({
                type: "ShipmentUnLoading",
                id: _id,
              })),
              { type: "ShipmentUnLoading", id: "DDL" },
            ]
          : [{ type: "ShipmentUnLoading", id: "DDL" }],
    }),
    getUnloadingReloadShipments: builder.query({
      query: (params) => ({
        url: `${SHIPMENT_UNLOADING_BASE_URL}/getUnloadingReloadShipments`,
        params,
      }),
      transformResponse: (response) => {
        if (Array.isArray(response)) {
          return response;
        }
        if (response && typeof response === "object") {
          return Object.values(response);
        }
        return [];
      },
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({
                type: "ShipmentUnLoading",
                id: _id,
              })),
              { type: "ShipmentUnLoading", id: "DDL" },
            ]
          : [{ type: "ShipmentUnLoading", id: "DDL" }],
    }),

    listShipmentsByUnloadingIds: builder.query({
      query: ({ unloadingId, page, limit }) => ({
        url: `${SHIPMENT_UNLOADING_BASE_URL}/${unloadingId}/shipments`,
        params: { page, limit },
      }),
      providesTags: (result, error, { loadingId }) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "ShipmentUnLoading",
                id: _id,
              })),
              { type: "ShipmentUnLoading", id: loadingId },
              { type: "ShipmentUnLoading", id: "LIST" },
            ]
          : [
              { type: "ShipmentUnLoading", id: loadingId },
              { type: "ShipmentUnLoading", id: "LIST" },
            ],
    }),
  }),
});

export const {
  useAddShipmentUnLoadingMutation,
  useAddShipmentUnloadingForDriverMutation,
  useAddFreeUnloadingMutation,
  useListShipmentUnLoadingQuery,
  useLazyListShipmentUnLoadingQuery,
  useLazyListShipmentUnLoadingCountQuery,
  useLazyGetDDLShipmentUnLoadingListQuery,
  useGetShipmentUnLoadingQuery,
  useGetShipmentUnLoadingDetailQuery,
  useUpdateShipmentUnLoadingMutation,
  useLazyGetDdlUnLoadingByUnloadingBranchQuery,
  useLazyGetUnloadingReloadShipmentsQuery,
  useListShipmentsByUnloadingIdsQuery,
  useLazyListShipmentsByUnloadingIdsQuery,
  useLazyGetDDLShipmentListForLoadingQuery,
} = ShipmentUnLoadingApi;
